export function startTimeNotInPastIfToday(eventDateFieldName) {
  return (value, ctx) => {
    const eventDateRaw = ctx.parent[eventDateFieldName];

    // If no date is chosen yet, skip this validation
    if (!eventDateRaw) {
      return true;
    }

    const eventDate =
      eventDateRaw instanceof Date ? eventDateRaw : new Date(eventDateRaw);

    // If eventDate cannot be parsed, skip validation to avoid runtime errors
    if (Number.isNaN(eventDate.getTime())) {
      return true;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const eventDay = new Date(eventDate);
    eventDay.setHours(0, 0, 0, 0);

    const isToday = eventDay.getTime() === today.getTime();

    if (!isToday) {
      return true;
    }

    // If time not provided, let the required rule handle it
    if (!value) {
      return true;
    }

    const now = new Date();
    const [datePart] = now.toISOString().split('T');
    const inputTime = new Date(`${datePart}T${value}`);

    if (Number.isNaN(inputTime.getTime())) {
      return true;
    }

    return inputTime.getTime() >= now.getTime();
  };
}
